const global = {
    baseUrl:'http://www.yzyzzb.com/api/',   //线上
    //baseUrl:'http://gw.fuhua91.com//api',     //测试
}


export default global